import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {DifficultyType} from "../../../Domain/Models/Cube";
import CubeHelp from "../../../Domain/Models/CubeHelp";
import Loading from "../../UiComponents/Loading";
import {cubeHelpRepository} from "../../../Domain/Repositories/CubeHelpRepository";
import ErrorCardController from "../../UiComponents/ErrorCardController";
import {Edit, Help} from "@material-ui/icons";
import CubeHelpModal from "./CubeHelpModal";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));

export interface CubeHelpElementProps
{
  cubeId: string;
  difficulty: DifficultyType;
  errorCardController: React.RefObject<ErrorCardController>;
}

export default function CubeHelpElement(props: CubeHelpElementProps)
{
  const classes = useStyles();
  const {cubeId, difficulty, errorCardController} = props;

  const [loading, setLoading] = useState(false);
  const [cubeHelp, setCubeHelp] = useState<CubeHelp>();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDialogClose = () =>
  {
    setDialogOpen(false);
    forceReload();
  }

  const forceReload = () =>
  {
    setLoading(true);

    cubeHelpRepository.getByCubeId(cubeId, difficulty)
      .then((helpInfo) =>
      {
        setCubeHelp(helpInfo);
        setLoading(false);
      })
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardController.current?.addErrorMessage(e.message);
      });
  }

  useEffect(() =>
  {
    forceReload();
  }, []);

  return (
    <>
      {cubeHelp && (
        <CubeHelpModal open={dialogOpen} onClose={handleDialogClose} cubeHelp={cubeHelp}/>
      )}

      <Paper className={classes.paper}>
        <Loading isLoading={loading}>
          <Toolbar>
            <Typography className={classes.title} component="h3" variant="h6" color="primary" gutterBottom>
              {`Cube Help - ${difficulty.toString()}`}
            </Typography>
            <IconButton size="medium" color="default" onClick={() => setDialogOpen(true)}>
              <Edit/>
            </IconButton>
          </Toolbar>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Heading</TableCell>
                  <TableCell>Content</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key={`Cube_${difficulty}_Rules`} hover>
                  <TableCell>Rules</TableCell>
                  <TableCell>{cubeHelp?.rules}</TableCell>
                </TableRow>
                <TableRow key={`Cube_${difficulty}_Additional`} hover>
                  <TableCell>Additional Info</TableCell>
                  <TableCell>{cubeHelp?.additionalInfo}</TableCell>
                </TableRow>
                <TableRow key={`Cube_${difficulty}_Reset`} hover>
                  <TableCell>Reset Info</TableCell>
                  <TableCell>{cubeHelp?.resetInfo}</TableCell>
                </TableRow>
                <TableRow key={`Cube_${difficulty}_Simplify`} hover>
                  <TableCell>Simplify Info</TableCell>
                  <TableCell>{cubeHelp?.simplifyInfo}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Loading>

      </Paper>
    </>
  )
}